<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Notifications</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher
    slot="fixed"
    (ionRefresh)="handleRefresh($event)"
    color="primary"
  >
    <ion-refresher-content
      pullingText="Pull to refresh"
      refreshingSpinner="circular"
      refreshingText="Refreshing..."
    >
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div class="ion-text-center" *ngIf="!isLoading">
    <div class="ion-padding ion-text-center" *ngIf="notifications.length ===0">
      <ion-text color="darkmimbo">You have no new notifications.</ion-text>
    </div>
  </div>
  <ion-grid *ngIf="notifications.length>0">
    <ion-row *ngFor="let notification of notifications">
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-item
          [button]="true"
          detail="false"
          color="lightmimbo"
          (click)="goToURL(notification.url)"
        >
          <div
            class="unread-indicator-wrapper"
            slot="start"
            *ngIf="notification.isNew"
          >
            <div class="unread-indicator"></div>
          </div>
          <ion-label>
            <strong>{{notification.title}}</strong>
            <ion-text class="notif-content"
              >{{notification.description}}</ion-text
            ><br />
          </ion-label>
          <div class="metadata-end-wrapper" slot="end">
            <ion-note color="medium">{{notification.date}}</ion-note>
            <ion-icon color="medium" name="chevron-forward"></ion-icon>
          </div>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll
    (ionInfinite)="onIonInfinite($event)"
    *ngIf="!isLoading && HasMoreData"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
